import { readScopesEnabled } from "@/api";
import { useOrganization } from "@/contexts/frontend/organization/useOrganization";
import { Navigate, Outlet } from "react-router";

/** Mounts under ProtectedOrganizationRoute, which supplies the settings this reads. */
const ScopesEnabledRoute = () => {
    const { settings } = useOrganization();

    return readScopesEnabled(settings) ? (
        <Outlet />
    ) : (
        <Navigate to="/organizations/home" replace />
    );
};

export default ScopesEnabledRoute;
